import Raven from 'raven-js'

const DSN =
  process.env.NODE_ENV === 'production'
    ? process.env.FRONTEND_SENTRY_DSN || ''
    : 'http://b85564b04856496a9d65f01e4540d802@sentry.dev.zhihu.com/1958'
const config =
  process.env.NODE_ENV === 'production'
    ? { release: process.env.ARTIFACT_TAG }
    : {}

Raven.config(DSN, config).install()
window.Raven = Raven

window.onerror = function(...args) {
  const err = args.slice(-1)[0]
  console.error(err) // eslint-disable-line no-console
  Raven.captureException(err)
}



// WEBPACK FOOTER //
// ./src/raven.js